import React from 'react'
import { Route, Navigate } from 'react-router-dom'
import axios from 'axios'
import { useState, useEffect } from 'react'
import API_URL from '../../config'
import { setAuthToken } from '../../services/auth'

// Function to check if user is a reconciliation admin
const useIsReconciliationAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [retries, setRetries] = useState(0)

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        // Set auth token for the request
        const token = localStorage.getItem('token')
        console.log(
          'Auth check - Token from localStorage:',
          token ? 'Token exists' : 'No token found'
        )

        if (!token) {
          setLoading(false)
          return
        }

        setAuthToken(token)
        console.log(
          'Auth check - Authorization header:',
          axios.defaults.headers.common['Authorization']
        )

        // Get user profile data
        console.log('Auth check - Making profile request to:', `${API_URL}profile/`)
        const response = await axios.get(`${API_URL}profile/`)
        console.log('Auth check - Profile response:', response.data)

        // Check if user has staff privileges
        const hasStaffPrivilege = response.data.is_staff === true
        console.log('Auth check - Is admin:', hasStaffPrivilege)

        setIsAdmin(hasStaffPrivilege)
        setError(null)
      } catch (error) {
        console.error('Error checking admin status:', error)
        console.error(
          'Error details:',
          error.response
            ? {
                status: error.response.status,
                data: error.response.data,
              }
            : 'No response data'
        )

        setError(error)

        // If we haven't tried too many times, try again
        if (retries < 3) {
          setRetries((prev) => prev + 1)
          return // Don't set loading to false yet
        }

        setIsAdmin(false)
      } finally {
        setLoading(false)
      }
    }

    checkAdminStatus()
  }, [retries])

  return { isAdmin, loading, error }
}

// Protected route component
const ReconciliationAdminRoute = ({ element }) => {
  const { isAdmin, loading, error } = useIsReconciliationAdmin()

  // Show loading state while checking permissions
  if (loading) {
    return <div className='p-4'>Checking permissions...</div>
  }

  // If there was an error but we know the user is an admin from a previous response
  if (error && isAdmin) {
    return element
  }

  // If not an admin, redirect to unauthorized page
  if (!isAdmin) {
    return <Navigate to='/unauthorized' />
  }

  // If admin, render the requested page
  return element
}

export default ReconciliationAdminRoute
